<template>
  <div class="modal" :class="{ 'is-active': is_open }">
    <div class="modal-background" @click="close"></div>
    <div class="modal-card is-fullscreen">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ $t("reject reason") }}
        </p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="save">
          <!-- Basic fields -->

          <generic-dropdown
            :title="$t('select reject reason')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/credit-analysis/deny-reason/catalog"
            name_field="name"
            value_field="uuid"
            @selected="deny_reason_selected"
            ref="deny_reason_dropdown"
          />
        </form>
      </section>

      <footer class="modal-card-foot">
        <button
          class="button is-success is-rounded"
          @click="save"
          :disabled="is_loading"
        >
          <span class="icon" v-if="is_loading">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
          <span class="icon" v-else>
            <i class="fa fa-save"></i>
          </span>
          <span>{{ $t("save") }}</span>
        </button>
        <button class="button is-rounded ml-3" @click="close">
          {{ $t("cancel") }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  get,
  post,
  put,
  success_message,
  error_message,
  format_date,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "CreditAnalysisDenyReasonModal",
  components: {
    GenericDropdown,
  },
  data() {
    return {
      is_open: false,
      is_editing: false,
      is_loading: false,
      uuid: null,
      form: {
        name: "",
        description: "",
        status: "active",
        settings: {},
      },
    };
  },
  methods: {
    open(request_uuid = null) {
      this.is_open = true;
      this.resetForm();

      this.form.request_uuid = request_uuid;
    },
    close() {
      this.is_open = false;
      this.resetForm();
    },
    resetForm() {
      this.form = {
        deny_reason_id: null,
        request_uuid: null,
      };
    },
    save() {
      if (!this.form.deny_reason_id) {
        error_message(this.$t("deny reason is required"));
        return;
      }

      this.is_loading = true;
      const data = {
        deny_reason_id: this.form.deny_reason_id,
        request_uuid: this.form.request_uuid,
      };
      const request = post("/credit-analysis/request/deny", data);

      request
        .then(() => {
          success_message(this.$t("request was denied successfully"));
          this.$emit("denied");
          this.close();
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    deny_reason_selected(deny_reason) {
      if (deny_reason) this.form.deny_reason_id = deny_reason.deny_reason_id;
    },
  },
};
</script>

<style scoped>
.modal.is-fullscreen .modal-card {
  width: 90vw;
  height: 90vh;
  max-width: 90vw;
  max-height: 90vh;
  margin: 0;
  border-radius: 15px;
}

.modal.is-fullscreen .modal-card-body {
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  padding: 2rem;
}

.modal.is-fullscreen .modal-card-head {
  border-radius: 0;
}

.modal.is-fullscreen .modal-card-foot {
  border-radius: 0;
}

.help {
  font-size: 0.875rem;
  color: #888;
}

.field {
  margin-bottom: 1.5rem;
}

/* Vertical tabs styling */
.tabs.is-vertical {
  display: block;
}

.tabs.is-vertical ul {
  flex-direction: column;
  border-bottom: none;
  /* border-right: 1px solid #dbdbdb; */
}

.tabs.is-vertical li {
  display: block;
  width: 100%;
}

.tabs.is-vertical li:not(:last-child) {
  margin-right: 0;
  margin-bottom: 0;
}

.tabs.is-vertical li a {
  /* border-bottom: 1px solid #dbdbdb; */
  border-radius: 4px 0 0 4px;
  justify-content: flex-start;
  padding: 0.75em 1em;
  display: flex;
  align-items: center;
}

.tabs.is-vertical li.is-active a {
  background-color: #3273dc;
  border-color: #3273dc;
  color: #fff;
}

.tabs.is-vertical li a:hover {
  background-color: #646060;
  border-color: #b5b5b5;
}

.tabs.is-vertical li.is-active a:hover {
  background-color: #2366d1;
  border-color: #2366d1;
}

.tab-link {
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.rule-content {
  min-height: 400px;
}

.delete.is-small {
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
}

.fixed-width-control {
  max-width: 150px;
}

.help {
  font-size: 0.875rem;
  color: #888;
}
</style>
